import { render } from "./FormCreation.vue?vue&type=template&id=bf0125aa&scoped=true"
import script from "./FormCreation.vue?vue&type=script&lang=js"
export * from "./FormCreation.vue?vue&type=script&lang=js"

import "./FormCreation.vue?vue&type=style&index=0&id=bf0125aa&scoped=true&lang=css"

import exportComponent from "/Users/user/Development/spin-demo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf0125aa"]])

export default __exports__